import { render, staticRenderFns } from "./FeeBillingSettings.vue?vue&type=template&id=c3b47996"
import script from "./FeeBillingSettings.vue?vue&type=script&lang=js"
export * from "./FeeBillingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports